<template>
    <div>
<!--page title start-->

<section class="page-title animatedbg dark-bg text-center" data-bg-img="images/pattern/01.png">
  <div class="container">
    <div class="row">
      <div class="col">
        <h1>{{ name }}</h1>
        <nav aria-label="breadcrumb" class="page-breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="index.html"> Home </a>
            </li>
            <li class="breadcrumb-item"><a href="#">Pages</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page"> {{name}} </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</section>

<!--page title end-->

    </div>
</template>

<script>
export default {
    props: ['name'],
}
</script>